module.exports = __webpack_public_path__ + "eb5a9ad858decc0ad1a260a587863b98.svg";